
import en from '../Locales/en.json'; 
import ar from '../Locales/ar.json';

const translations = { en, ar };

export const getCurrentLang = () => {
  return localStorage.getItem('lang') || 'en';
};

export const getTranslations = (lang) => {
  const languageToUse = lang || getCurrentLang();
  return translations[languageToUse] || translations.en; 
};
export const t = () => {
  const lang = getCurrentLang();
  return translations[lang] || translations.en;
};


export const toggleLangAndGetNext = () => {
  const currentStoredLang = localStorage.getItem('lang') || 'en';
  const nextLang = currentStoredLang === 'en' ? 'ar' : 'en';
  localStorage.setItem('lang', nextLang);
  document.documentElement.lang = nextLang;
  document.documentElement.dir = nextLang === 'ar' ? 'rtl' : 'ltr'; 
  console.log('Language toggled in localStorage and document to (no reload):', nextLang);
  return nextLang; 
window.location.reload()
};

/**
 * React
 * SPA = Single Page Application
 * State = Data State Changes => (useEffect , useState , useReducer, useMemo, useCallback) 
 * No Required Reload
 * 
 * Global State Management (Redux , Recoil , Zustand)
 * Context API (React Context)
 * 
 */